// Constants for different requests for current reducer
export default {
  getClient: 'GET_CLIENT',
  clients: 'CLIENTS',
};
